import React from "react";
import { css } from "emotion";
import { colors, textSizes, boxStyles } from "../styles/theme";
import { darken } from "polished";

const GenericButton = ({ text, handleClick, style, disabled }) => {
  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      className={
        `${style ? style : ""} ` + container + ` ${disabled ? disabledBtn : ""}`
      }
    >
      {text.toUpperCase()}
    </button>
  );
};

export default GenericButton;

const container = css`
  background-color: ${colors.brandColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 24px;
  width: 100%;
  box-shadow: ${boxStyles.boxShadow};
  cursor: pointer;
  transition-duration: 0.2s;
  padding: 10px 0;
  font-weight: bold;
  font-size: ${textSizes.intermediate};
  color: white;

  &:hover {
    background-color: ${darken(0.1, colors.brandColor)};
  }
`;

const disabledBtn = css`
  cursor: wait;
  pointer-events: none;
  opacity: 0.5;
`;
